import React, { Component } from 'react';
import SearchProduct from './SearchProduct';
import { branch } from 'baobab-react/higher-order';

class LocateProductManual extends Component {
	render() {
		return (
			<section className="section section-locate-product-manual">
				<div className="section-header row text-center">
					<div className="col">
						<h2>Find My Product Manual</h2>
						<p>Enter your model number below to locate and download a copy of your product manual.</p>
					</div>
				</div>
				<div className="section-content row">
					<div className="col">
						<SearchProduct product={ this.props.product } />
					</div>
				</div>
			</section>
		);
	}
};

export default branch({
	token: ['token'],
	product: ['product']
}, LocateProductManual);


// WEBPACK FOOTER //
// ./src/pages/support/productManuals/LocateProductManual.js